import { TRoute } from "@/shared/types/route";
import MapPreviewPage from "./pages/map-preview-page";
import LegacyMapRedirect from "./pages/legacy-map-redirect";
import { MAP_URL } from "./config/map-urls";

const MAP_ROOT_ROUTE: TRoute = {
  name: "Map",
  path: MAP_URL.ROOT,
  component: MapPreviewPage,
  roles: [],
};

/** The map used to live here; kept so old links and bookmarks still resolve. */
const MAP_LEGACY_ROUTE: TRoute = {
  name: "Map (legacy path)",
  path: MAP_URL.LEGACY_ROOT,
  component: LegacyMapRedirect,
  roles: [],
};

const MAP_ROUTES = {
  MAP_ROOT_ROUTE,
  MAP_LEGACY_ROUTE,
} as const;

export { MAP_URL, MAP_ROUTES };
